export interface UnsavedChangesGuard {
  isDirty: () => boolean;
  requestLeave: (onLeave: () => void) => void;
}

let activeGuard: UnsavedChangesGuard | null = null;

export const registerUnsavedChangesGuard = (guard: UnsavedChangesGuard) => {
  activeGuard = guard;
};

export const unregisterUnsavedChangesGuard = (guard: UnsavedChangesGuard) => {
  if (activeGuard === guard) {
    activeGuard = null;
  }
};

export const tryNavigateWithUnsavedGuard = (onLeave: () => void) => {
  if (activeGuard?.isDirty()) {
    activeGuard.requestLeave(onLeave);
    return;
  }
  onLeave();
};
